export const ID_EVENTOS = 1;
export const ID_FOCA = 2;
export const ID_PPM = 3;
